import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer/Footer";
import Navbar from "./Navbar/Navbar";
import MainContent from "./MainContent/MainContent";
import ThemeToggle from "../ThemeToggle/ThemeToggle";

export default function PublicLayoutPages() {
  const location = useLocation();

  // الصفحات التي لا نريد إظهار العناصر فيها
  const hiddenLayoutRoutes = ["/"];

  const hideLayout = hiddenLayoutRoutes.includes(location.pathname);

  return (
    <div>
      <MainContent>
        {!hideLayout && <Navbar />}
        <Outlet />
        {<Footer />}
      </MainContent>

      {<ThemeToggle />}
    </div>
  );
}
